import * as z from 'zod';

const AddresseZod = z.object({
  id: z.number(),
  city: z.string().nullish(),
  street: z.string().nullish(),
  detail: z.string().nullish(),
});

export { AddresseZod };
export type AddresseType = z.infer<typeof AddresseZod>;
